//Doing this service just for legacy purposes
import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  constructor() { }

  get(){
    return environment;
  }
}
